// extracted by mini-css-extract-plugin
export default {"root":"_1ZI_c","scrollable":"_34BiH","size-small":"MhpWQ","sizeSmall":"MhpWQ","size-medium":"_1IE7V","sizeMedium":"_1IE7V","tag-item":"_13bfj","tagItem":"_13bfj"};